function initialState() {
  return {
    library: {
      url: "",
      token: "",
      uploader: "",
    },
    
    playlistMedia: [],
    uploadingMediaList: [],
    uploadProcessing: null,
  };
}

let state = initialState();

export { initialState, state };
